import type {
  AnalyticsService,
  AnalyticsServiceEvent,
  AnalyticsServicePage,
} from '@application/AnalyticsService';
import type {
  AnonymousUser,
  Group,
  UserInformation,
  UserInformationService,
} from '@application/UserInformationService';
import { init } from './SegmentWrapper';

export class SegmentService
  implements UserInformationService, AnalyticsService
{
  constructor({
    apiKey,
    domain,
    cdnHost,
  }: {
    apiKey: string;
    domain: string;
    cdnHost: string;
  }) {
    init({ apiKey, domain, cdnHost });
  }

  setUserInformation = (user: UserInformation | AnonymousUser) => {
    if (user) return globalThis.analytics?.identify(user.id, user);
    return globalThis.analytics?.reset();
  };

  logEvent = ({ name, payload, url }: AnalyticsServiceEvent) => {
    return globalThis.analytics?.track(name, payload, {
      context: {
        page: { url: url?.toString(), search: url?.search },
        campaign: url && getUtmParams(url.searchParams),
      },
    });
  };

  logPage = ({ name, category, payload }: AnalyticsServicePage) => {
    if (category) {
      return globalThis.analytics?.page(category, name, payload);
    }
    return globalThis.analytics?.page(name, payload);
  };

  setGroup = (group: Group | null) => {
    if (group) {
      globalThis.analytics?.group(group.groupId, group);
    }
  };
}

const getUtmParams = (searchParams: URLSearchParams | undefined) => ({
  source: searchParams?.get('utm_source'),
  medium: searchParams?.get('utm_medium'),
  name: searchParams?.get('utm_campaign'),
  content: searchParams?.get('utm_content'),
  term: searchParams?.get('utm_term'),
});
